// extracted by mini-css-extract-plugin
module.exports = {"group":"form_group_group__3-IRL","title":"form_group_title__1qZF7","content":"form_group_content__QcaQG"};